import { ANIMATION } from '../dataSource';
import { genId, genRecord } from './utils';

const ANIMATION_PRE_LENGTH = 12;
const ANIMATION_ATTR_PRE_LENGTH = 4;

const SelectMethodMap: { [key: string]: number } = {
  inOrder: 0,
  inReverseOrder: 1,
  random: 2
};

const getAttrs = (attrs: Ast[]) => {
  return attrs.map((attrAst: Ast) => {
    const { attr } = attrAst.attrsMap;

    const data = Buffer.from(attr.replaceAll('&quot;', '"'));
    const len = data.length;
    return {
      len: len,
      data,
      totalLength: ANIMATION_ATTR_PRE_LENGTH + len
    };
  });
};
export const getAnimationData = (resource: Ast, curDataAddress: number) => {
  const { attrsMap, children } = resource;
  const { name, selectMethod } = attrsMap;
  const type = ANIMATION;

  const attrs = getAttrs(children);
  const select_method = SelectMethodMap[selectMethod];

  const data_len = attrs.reduce(
    (prev, current) => prev + current.totalLength,
    0
  );

  const originData = {
    type,
    attr_cnt: attrs.length,
    select_method,
    data_len,
    attrs,
    totalLength: ANIMATION_PRE_LENGTH + data_len
  };
  // 记录
  const uid = genId(type);
  const originRecord = genRecord(
    type,
    name,
    uid,
    curDataAddress,
    originData.totalLength || 0
  );
  return { originData, originRecord };
};
